export default __webpack_public_path__ + "bb31be299edf0e986a5b9aed482fe6ac.png";